import { cn } from '@/lib/utils'
import type { DashboardWidgetDefinition } from './registry'

interface DashboardWidgetGridProps {
  widgets: DashboardWidgetDefinition[]
}

/** Renders a role's widget list in order, pairing up adjacent 'half'-span widgets
 * two-per-row and giving every 'full'-span widget its own row. */
export function DashboardWidgetGrid({ widgets }: DashboardWidgetGridProps) {
  const rows: DashboardWidgetDefinition[][] = []
  for (let i = 0; i < widgets.length; i++) {
    const w = widgets[i]
    const next = widgets[i + 1]
    if (w.span === 'half' && next?.span === 'half') {
      rows.push([w, next])
      i++
    } else {
      rows.push([w])
    }
  }

  return (
    <>
      {rows.map((row) => (
        <div
          key={row.map(w => w.id).join('+')}
          className={cn('mb-5', row.length === 2 && 'grid grid-cols-2 gap-4 max-md:grid-cols-1')}
        >
          {row.map(w => <w.component key={w.id} />)}
        </div>
      ))}
    </>
  )
}
